import { Subject } from "rxjs";
import { apiUrls } from "../Common";
import API from "../Common/AxiosConfiguration";

const subject = new Subject();

export const CalendarService = {
  getObserved: () => subject.asObservable(),
  getEvents: async (form) => {
    const response = await API.post(apiUrls.listEvent, form);
    return response;
  },

  setEvent: async (form) => {
    const response = await API.post(apiUrls.addEvent, form);
    return response;
  },

  updateEvent: async (form) => {
    const response = await API.post(apiUrls.updateEvent, form);
    return response;
  },

  removeEvent: async (form) => {
    const response = await API.post(apiUrls.deleteEvent, form);
    return response;
  },
};
